import store from "@/store";
import {NavigationGuardNext, Route} from "vue-router";
export default async (to: Route, from: Route, next: NavigationGuardNext) => {
    // Obtenemos el status de la sesión del usuario
    let isAuthenticated = store.getters["auth/isAuthenticated"];
    if (isAuthenticated) {
        next({ name: 'Full' });
        return false;
    }
}
